import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '@app/services/account.service';

@Component({
  selector: 'app-confirm-email',
  standalone: false,
  template: '',
})
export class ConfirmEmailComponent {
  constructor(
    route: ActivatedRoute,
    router: Router,
    accountService: AccountService,
  ) {
    route.queryParams.subscribe((value) => {
      const token = value['token'] ?? '';
      const hashId = value['hashid'] ?? '';
      if (token && hashId) {
        accountService
          .confirmEmail({
            token,
            identifier: hashId,
          })
          .subscribe({
            next: () => router.navigateByUrl('/auth/login'),
            error: () => router.navigateByUrl('/auth/login'),
          });
      } else {
        router.navigateByUrl('/auth/login');
      }
    });
  }
}
